import React, { useEffect, useRef, useState } from 'react'
import statusIcon from '../assets/icons/ic_status.svg'
import downIcon from '../assets/icons/ic_arrowdown.svg'
import upIcon from '../assets/icons/ic_arrowup.svg'
import notifIcon from '../assets/icons/ic_notif.svg'
import settingsIcon from '../assets/icons/ic_settings.svg'
import chatIcon from '../assets/icons/ic_chat.svg'
import IconTint from 'react-icon-tint';
import { db } from '../firebase-config'
import { doc, getDoc } from 'firebase/firestore';
import { useAtom, useSetAtom } from 'jotai'
import { currentRobot, isPageChanged, loggedInUser, robotNickname, selectedPage } from './store/DataStore'

const Header = () => {
    const setSavedPos = useSetAtom(selectedPage);
    const setIsFragmentChanged = useSetAtom(isPageChanged);
    const [currentUser] = useAtom(loggedInUser);

    const onSettingsClick = () => {
        setSavedPos(6);
        setIsFragmentChanged(false);
    }

    const onNotifClick = () => {
        console.log("Notif clicked");
    }

    const onChatClick = () => {
        console.log("chat clicked");
    }

    return (
        <div className='flex w-full flex-col gap-3 sm:flex-row sm:items-start sm:justify-between'>
            <RobotsDropdown />
            <div className='flex h-fit flex-wrap justify-end gap-3 sm:max-w-[50%]'>
                <div onClick={onNotifClick} className='cursor-pointer rounded-xl bg-[#3C5BD2] bg-opacity-10 p-2 hover:bg-opacity-5'>
                    <img src={notifIcon} alt='notifications' className='h-6' />
                </div>
                {['Admin', 'Tech Support'].includes(currentUser?.role) && (
                  <div onClick={onSettingsClick} className='cursor-pointer rounded-xl bg-[#3C5BD2] bg-opacity-10 p-2 hover:bg-opacity-5'>
                      <img src={settingsIcon} alt='settings' className='h-6' />
                  </div>
                )}
                <div onClick={onChatClick} className='cursor-pointer rounded-xl bg-[#3C5BD2] bg-opacity-10 p-2 hover:bg-opacity-5'>
                    <img src={chatIcon} alt='chat' className='h-6' />
                </div>
            </div>
        </div>
    )
}

const RobotsDropdown = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedRobot, setSelectedRobot] = useAtom(currentRobot)
    const [selectedNickname, setSelectedNickname] = useAtom(robotNickname);
    const toggleDropdown = () => setIsOpen(!isOpen);
    const myComponentRef = useRef(null);
    const [currentUser] = useAtom(loggedInUser);
    const [matchedRobots, setMatchedRobots] = useState([]);

    useEffect(() => {
        const fetchNicknames = async () => {
            try {
                const docRef = doc(db, 'Companies', 'Zeeno_Dev', 'Robots', 'robots');
                const docSnapshot = await getDoc(docRef);

                if (docSnapshot.exists()) {
                    const data = docSnapshot.data();
                    if (data.nicknames && Array.isArray(data.nicknames)) {
                        const allNicknames = data.nicknames;
                        let filteredNicknames;
                
                        if (currentUser.role === 'Tech Support') {
                            filteredNicknames = allNicknames;
                        } else {
                            filteredNicknames = allNicknames.filter(nickname => currentUser.robots.includes(nickname.number));
                        }
                
                        setMatchedRobots(filteredNicknames);
                
                        if (selectedRobot === '' || selectedNickname === '') {
                            setSelectedNickname(filteredNicknames[0].name);
                            setSelectedRobot(filteredNicknames[0].number);
                        }
                    }
                }
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        };
        fetchNicknames();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    document.addEventListener("mousedown", (e) => {
        if (myComponentRef.current && !myComponentRef.current.contains(e.target)) {
            setIsOpen(false);
        }
    });

    const onRobotSelected = (item) => {
        setIsOpen(false);
        setSelectedRobot(item)
    }

    return (
        <div ref={myComponentRef} className="relative w-full max-w-[320px] transition-all delay-200 select-none sm:w-fit sm:min-w-[220px]">
            <div onClick={toggleDropdown} className={`flex w-full cursor-pointer flex-row items-center justify-between bg-[#3C5BD2] bg-opacity-10 py-2 pl-2 pr-3 ${isOpen ? 'rounded-bl-none rounded-rb-none rounded-tr-lg rounded-tl-2xl' : 'rounded-r-lg rounded-l-2xl hover:bg-opacity-5'} focus:outline-none`}>
                <img src={statusIcon} alt='status' className='h-6' />
                <span className='ml-2 w-full truncate text-ellipsis font-heebo font-normal text-[#3C5BD2]'>{selectedNickname}</span>
                {!isOpen ? <IconTint src={downIcon} className='h-3 w-3 flex-shrink-0' color='#3C5BD2' /> : <IconTint src={upIcon} className='-mt-1 h-3 w-3 flex-shrink-0' color='#3C5BD2' />}
            </div>

            {isOpen && (
                <div className="absolute left-0 z-10 w-full rounded-b-md bg-[#e1e6fd] py-2 shadow-xl">
                    {matchedRobots.map((item, index) => (
                        <span
                            key={index}
                            className="block px-4 py-2 text-sm text-[#3C5BD2] cursor-pointer font-heebo hover:bg-[#b9c7ff44]"
                            onClick={() => {
                                if (item.name == null) {
                                    setSelectedNickname(item.number);
                                } else {
                                    setSelectedNickname(item.name);
                                }
                                onRobotSelected(item.number);
                            }}
                        >{`${item.name == null ? item.number : item.name}`}</span>
                    ))
                    }
                </div>
            )}
        </div>
    );
};

export default Header




